import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withModifiers as _withModifiers, resolveDirective as _resolveDirective, normalizeStyle as _normalizeStyle, vModelRadio as _vModelRadio } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "image-process-container"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  id: "dvEmailContainer",
  class: "left-content-container"
}
const _hoisted_4 = { class: "email-settings-header" }
const _hoisted_5 = { class: "margin-left-30" }
const _hoisted_6 = { class: "margin-bottom-10" }
const _hoisted_7 = { class: "color-red" }
const _hoisted_8 = ["maxlength"]
const _hoisted_9 = { class: "position-relative" }
const _hoisted_10 = { class: "font-dropdown" }
const _hoisted_11 = ["value"]
const _hoisted_12 = { class: "margin-top-30" }
const _hoisted_13 = { class: "title-headers" }
const _hoisted_14 = { class: "email-appearance-settings" }
const _hoisted_15 = { class: "margin-right-15" }
const _hoisted_16 = { class: "display-flex flex-direction-column margin-right-15 margin-bottom-10" }
const _hoisted_17 = { class: "fields-title" }
const _hoisted_18 = { class: "logo-cover" }
const _hoisted_19 = { class: "logo-positions" }
const _hoisted_20 = { class: "logo-positions-title" }
const _hoisted_21 = { class: "fields-title" }
const _hoisted_22 = { class: "logo-positions-pills" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "logo-position-header" }
const _hoisted_25 = { class: "display-flex flex-direction-column margin-top-15" }
const _hoisted_26 = { class: "title-headers" }
const _hoisted_27 = { class: "display-flex padding-0 margin-top-10" }
const _hoisted_28 = { class: "display-flex flex-direction-column margin-right-15" }
const _hoisted_29 = { class: "fields-title" }
const _hoisted_30 = { class: "display-flex flex-direction-column margin-right-15" }
const _hoisted_31 = { class: "fields-title" }
const _hoisted_32 = { class: "margin-top-10" }
const _hoisted_33 = { class: "display-flex justify-content-space-between" }
const _hoisted_34 = { class: "margin-top-20" }
const _hoisted_35 = { class: "inlineInput margin-bottom-10" }
const _hoisted_36 = { class: "form-action" }
const _hoisted_37 = { class: "margin-right-15" }
const _hoisted_38 = { class: "fields-title" }
const _hoisted_39 = { class: "margin-right-15" }
const _hoisted_40 = { class: "fields-title" }
const _hoisted_41 = { class: "button-field" }
const _hoisted_42 = { class: "margin-top-0" }
const _hoisted_43 = { class: "color-red" }
const _hoisted_44 = ["maxlength"]
const _hoisted_45 = { class: "display-flex padding-0" }
const _hoisted_46 = {
  key: 0,
  class: "display-flex flex-direction-column margin-right-15"
}
const _hoisted_47 = { class: "fields-title" }
const _hoisted_48 = { class: "display-flex flex-direction-column margin-right-15" }
const _hoisted_49 = { class: "fields-title" }
const _hoisted_50 = {
  key: 0,
  class: "inlineInput margin-bottom-10"
}
const _hoisted_51 = { class: "form-action" }
const _hoisted_52 = { class: "margin-right-15" }
const _hoisted_53 = { class: "fields-title" }
const _hoisted_54 = { class: "margin-right-15" }
const _hoisted_55 = { class: "fields-title" }
const _hoisted_56 = { class: "display-flex flex-direction-column" }
const _hoisted_57 = { class: "button-field" }
const _hoisted_58 = { class: "margin-top-0" }
const _hoisted_59 = { class: "color-red" }
const _hoisted_60 = ["maxlength"]
const _hoisted_61 = { class: "display-flex padding-0" }
const _hoisted_62 = {
  key: 0,
  class: "display-flex flex-direction-column margin-right-15"
}
const _hoisted_63 = { class: "fields-title" }
const _hoisted_64 = { class: "display-flex flex-direction-column margin-right-15" }
const _hoisted_65 = { class: "fields-title" }
const _hoisted_66 = {
  key: 0,
  class: "information-strip"
}
const _hoisted_67 = {
  key: 1,
  class: "inlineInput margin-bottom-10 margin-top-15"
}
const _hoisted_68 = { class: "display-flex padding-0" }
const _hoisted_69 = { class: "form-action" }
const _hoisted_70 = { class: "margin-right-15" }
const _hoisted_71 = { class: "fields-title" }
const _hoisted_72 = { class: "margin-right-15" }
const _hoisted_73 = { class: "fields-title" }
const _hoisted_74 = { class: "button-field" }
const _hoisted_75 = { class: "margin-top-0" }
const _hoisted_76 = { class: "color-red" }
const _hoisted_77 = ["maxlength"]
const _hoisted_78 = { class: "display-flex padding-0" }
const _hoisted_79 = {
  key: 0,
  class: "display-flex flex-direction-column margin-right-15"
}
const _hoisted_80 = { class: "fields-title" }
const _hoisted_81 = { class: "display-flex flex-direction-column margin-right-15" }
const _hoisted_82 = { class: "fields-title" }
const _hoisted_83 = {
  key: 2,
  class: "inlineInput margin-bottom-10 margin-top-15"
}
const _hoisted_84 = { class: "display-flex padding-0" }
const _hoisted_85 = { class: "form-action" }
const _hoisted_86 = { class: "margin-right-15" }
const _hoisted_87 = { class: "fields-title" }
const _hoisted_88 = { class: "margin-right-15" }
const _hoisted_89 = { class: "fields-title" }
const _hoisted_90 = { class: "button-field" }
const _hoisted_91 = { class: "margin-top-0" }
const _hoisted_92 = { class: "color-red" }
const _hoisted_93 = ["maxlength"]
const _hoisted_94 = { class: "display-flex padding-0" }
const _hoisted_95 = {
  key: 0,
  class: "display-flex flex-direction-column margin-right-15"
}
const _hoisted_96 = { class: "fields-title" }
const _hoisted_97 = { class: "display-flex flex-direction-column margin-right-15" }
const _hoisted_98 = { class: "fields-title" }
const _hoisted_99 = { class: "margin-top-15 margin-bottom-20" }
const _hoisted_100 = { class: "title-headers" }
const _hoisted_101 = { class: "display-flex padding-0 margin-top-10" }
const _hoisted_102 = { class: "display-flex flex-direction-column margin-right-15" }
const _hoisted_103 = { class: "fields-title" }
const _hoisted_104 = { class: "display-flex flex-direction-column margin-right-15" }
const _hoisted_105 = { class: "fields-title" }
const _hoisted_106 = { class: "margin-top-10" }
const _hoisted_107 = { class: "display-flex" }
const _hoisted_108 = ["disabled"]
const _hoisted_109 = ["disabled"]
const _hoisted_110 = { class: "right-content-container" }
const _hoisted_111 = { class: "display-flex justify-content-space-between email-preview-header" }
const _hoisted_112 = { class: "preview-label" }
const _hoisted_113 = { class: "email-canvas" }
const _hoisted_114 = { class: "preview-frame" }
const _hoisted_115 = { class: "footer-tab" }
const _hoisted_116 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ImageProcess = _resolveComponent("ImageProcess")!
  const _component_loading = _resolveComponent("loading")!
  const _component_Toaster = _resolveComponent("Toaster")!
  const _component_ConfigureEmailEditPaneModalPopUp = _resolveComponent("ConfigureEmailEditPaneModalPopUp")!
  const _component_ModalInputPopUp = _resolveComponent("ModalInputPopUp")!
  const _component_VueModalPopUp = _resolveComponent("VueModalPopUp")!
  const _component_ValidationSummary = _resolveComponent("ValidationSummary")!
  const _component_Twitter = _resolveComponent("Twitter")!
  const _component_ImageContainer = _resolveComponent("ImageContainer")!
  const _component_Editor = _resolveComponent("Editor")!
  const _component_EmailTemplateRenderer = _resolveComponent("EmailTemplateRenderer")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_ctx.ShowImageProcessSection())
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_ImageProcess, {
          "module-name": _ctx.moduleName,
          "sub-module-name": _ctx.subModuleName,
          "image-src": _ctx.GetLogoImageUrl(),
          "image-full-src": _ctx.GetLogoImageUrl(),
          "featuredimage-src": _ctx.GetHeroImageUrl(),
          "has-featured-image": true,
          "show-featured-image": _ctx.showHeroImage,
          "only-show-feature-image": _ctx.showHeroImage,
          "is-full-image": true,
          onSetImageIconUrl: _ctx.SetLogoUrl,
          onSetFeaturedImageIconUrl: _ctx.SetHerologoUrl,
          onSelectBack: _ctx.ClickOnImage,
          onDiscard: _ctx.SetLogoOldUrl,
          onDiscardFeature: _ctx.SetHeroImgOldUrl
        }, null, 8, ["module-name", "sub-module-name", "image-src", "image-full-src", "featuredimage-src", "show-featured-image", "only-show-feature-image", "onSetImageIconUrl", "onSetFeaturedImageIconUrl", "onSelectBack", "onDiscard", "onDiscardFeature"])
      ]))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "email-settings-container",
        onKeypress: _cache[65] || (_cache[65] = 
//@ts-ignore
(...args) => (_ctx.IsPageDirty && _ctx.IsPageDirty(...args))),
        onClick: _cache[66] || (_cache[66] = 
//@ts-ignore
(...args) => (_ctx.IsPageDirty && _ctx.IsPageDirty(...args))),
        onMousemove: _cache[67] || (_cache[67] = 
//@ts-ignore
(...args) => (_ctx.IsPageDirty && _ctx.IsPageDirty(...args))),
        onTouchstart: _cache[68] || (_cache[68] = 
//@ts-ignore
(...args) => (_ctx.IsPageDirty && _ctx.IsPageDirty(...args)))
      }, [
        _createVNode(_component_loading, {
          "show-loading": _ctx.showLoading,
          "border-color": _ctx.loaderBorderColor
        }, null, 8, ["show-loading", "border-color"]),
        (_ctx.showToaster)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_Toaster, {
                message: _ctx.toasterMessage,
                type: _ctx.toasterType,
                "default-timeout": _ctx.toasterDefaultTimeout
              }, null, 8, ["message", "type", "default-timeout"])
            ]))
          : _createCommentVNode("", true),
        (_ctx.showConfigureEmailEditPaneModal)
          ? (_openBlock(), _createBlock(_component_ConfigureEmailEditPaneModalPopUp, {
              key: 1,
              "custom-modal-pop-up": _ctx.customEmailModalPopUp,
              "custom-templates": _ctx.editTemplateData.AvailableTemplates,
              onClose: _ctx.HandleCloseModal,
              onSubmit: _ctx.HandleRecievedData
            }, null, 8, ["custom-modal-pop-up", "custom-templates", "onClose", "onSubmit"]))
          : _createCommentVNode("", true),
        (_ctx.showEmailModalPopUp)
          ? (_openBlock(), _createBlock(_component_ModalInputPopUp, {
              key: 2,
              "input-modal": _ctx.emailModalPopUp,
              onClose: _ctx.CloseInputModelPopup,
              onSubmit: _ctx.ConfirmEmailPopupClick
            }, null, 8, ["input-modal", "onClose", "onSubmit"]))
          : _createCommentVNode("", true),
        (_ctx.showVueModalPopUp)
          ? (_openBlock(), _createBlock(_component_VueModalPopUp, {
              key: 3,
              "modal-pop-up": _ctx.unsavedModalPopUp,
              onClose: _ctx.CloseModelPopup,
              onSave: _cache[0] || (_cache[0] = ($event: any) => (_ctx.SaveModelPopUp($event)))
            }, null, 8, ["modal-pop-up", "onClose"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("label", {
              class: _normalizeClass(["edit-email-label", {'small-tab-label' : _ctx.isSmallTab}])
            }, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditEmail.Title")), 3)
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_ctx.isValidationSummaryVisible)
              ? (_openBlock(), _createBlock(_component_ValidationSummary, {
                  key: 0,
                  "error-fields": _ctx.validationErrorFields,
                  onCloseClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.CloseValidationSummary($event)))
                }, null, 8, ["error-fields"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["email-settings-form", {'small-tab-container' : _ctx.isSmallTab}])
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("label", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditEmail.Subject")) + " ", 1),
                  _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t("Asteric")), 1)
                ]),
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.v$.editTemplateData.TemplateData.EmailSubject.$model) = $event)),
                  type: "text",
                  class: _normalizeClass(["form-control", _ctx.status(_ctx.v$.editTemplateData.TemplateData.EmailSubject)]),
                  maxlength: _ctx.maxSubjectLength
                }, null, 10, _hoisted_8), [
                  [
                    _vModelText,
                    _ctx.v$.editTemplateData.TemplateData.EmailSubject.$model,
                    void 0,
                    { trim: true }
                  ]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("label", null, [
                  _createTextVNode(_toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditEmail.FontFamily")) + " ", 1),
                  _createElementVNode("i", {
                    class: "fa fa-info-circle margin-left-5",
                    onMouseover: _cache[3] || (_cache[3] = ($event: any) => (_ctx.ShowHideFontFamilyInformationString(true))),
                    onMouseleave: _cache[4] || (_cache[4] = ($event: any) => (_ctx.ShowHideFontFamilyInformationString(false)))
                  }, null, 32)
                ]),
                _withDirectives(_createElementVNode("div", { class: "information-icon-div" }, _toDisplayString(_ctx.$t('Invite.ConfigureEmails.EditEmail.FontFamilyInformationString')), 513), [
                  [_vShow, _ctx.showFontFamilyInformation]
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _withDirectives(_createElementVNode("select", {
                    id: "selectFont",
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.editTemplateData.TemplateData.FontFamily) = $event)),
                    class: "form-control selectBox",
                    onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.OnFontChange && _ctx.OnFontChange(...args)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fontOptions, (font) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: font,
                        value: font
                      }, _toDisplayString(font), 9, _hoisted_11))
                    }), 128))
                  ], 544), [
                    [_vModelSelect, _ctx.editTemplateData.TemplateData.FontFamily]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditEmail.HeaderSection")), 1),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("label", _hoisted_17, _toDisplayString(_ctx.$t("Background")), 1),
                    _createElementVNode("div", {
                      class: "palette-container",
                      style: _normalizeStyle({ backgroundColor: _ctx.headerBackgroundColor.hex })
                    }, [
                      (!_ctx.isPaletteSelected[0])
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "color-block",
                            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.TogglePalette(0)), ["stop"]))
                          }))
                        : _withDirectives((_openBlock(), _createBlock(_component_Twitter, {
                            key: 1,
                            modelValue: _ctx.headerBackgroundColor,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.headerBackgroundColor) = $event)),
                            class: "color-picker"
                          }, null, 8, ["modelValue"])), [
                            [_directive_click_outside, _ctx.HideAllPalattes]
                          ])
                    ], 4)
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["logo-row margin-bottom-10", {'small-tab-display' : _ctx.isSmallTab}])
                  }, [
                    _createElementVNode("div", _hoisted_18, [
                      _createVNode(_component_ImageContainer, {
                        "image-container-data": _ctx.customEmailLogoData,
                        onImageContainerClicked: _cache[9] || (_cache[9] = ($event: any) => (_ctx.ClickOnBackgroundImage(_ctx.imageType.LogoImage)))
                      }, null, 8, ["image-container-data"])
                    ]),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createElementVNode("label", _hoisted_21, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditEmail.LogoPosition")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.logoPositions, (position) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: position,
                            class: _normalizeClass(["logo-position", { selected: _ctx.editTemplateData.TemplateData.LogoPosition === position }]),
                            type: "button",
                            onClick: ($event: any) => (_ctx.ChangeLogoPosition(position))
                          }, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["logo-pill", position])
                              }, null, 2)
                            ]),
                            _cache[69] || (_cache[69] = _createElementVNode("div", { class: "logo-position-body" }, null, -1))
                          ], 10, _hoisted_23))
                        }), 128))
                      ])
                    ])
                  ], 2),
                  _createVNode(_component_ImageContainer, {
                    "image-container-data": _ctx.customEmailHeroImageData,
                    onImageContainerClicked: _cache[10] || (_cache[10] = ($event: any) => (_ctx.ClickOnBackgroundImage(_ctx.imageType.HeroImage)))
                  }, null, 8, ["image-container-data"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("label", _hoisted_26, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditEmail.BodySection")), 1),
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.$t("Background")), 1),
                  _createElementVNode("div", {
                    class: "palette-container",
                    style: _normalizeStyle({'backgroundColor': _ctx.bodyBackgroundColor.hex})
                  }, [
                    (!_ctx.isPaletteSelected[1])
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "color-block",
                          onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.TogglePalette(1)), ["stop"]))
                        }))
                      : _withDirectives((_openBlock(), _createBlock(_component_Twitter, {
                          key: 1,
                          modelValue: _ctx.bodyBackgroundColor,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.bodyBackgroundColor) = $event)),
                          class: "color-picker"
                        }, null, 8, ["modelValue"])), [
                          [_directive_click_outside, _ctx.HideAllPalattes]
                        ])
                  ], 4)
                ]),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("label", _hoisted_31, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditEmail.TextColor")), 1),
                  _createElementVNode("div", {
                    class: "palette-container",
                    style: _normalizeStyle({'backgroundColor': _ctx.bodyFontColor.hex})
                  }, [
                    (!_ctx.isPaletteSelected[2])
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "color-block",
                          onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_ctx.TogglePalette(2)), ["stop"]))
                        }))
                      : _withDirectives((_openBlock(), _createBlock(_component_Twitter, {
                          key: 1,
                          modelValue: _ctx.bodyFontColor,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.bodyFontColor) = $event)),
                          class: "color-picker"
                        }, null, 8, ["modelValue"])), [
                          [_directive_click_outside, _ctx.HideAllPalattes]
                        ])
                  ], 4)
                ])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("div", null, [
                    _createElementVNode("label", null, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditEmail.Content")), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("a", {
                      href: "javascript:void(0)",
                      class: "merge-tag-link",
                      onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.OpenMergeTagsModal && _ctx.OpenMergeTagsModal(...args)))
                    }, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.MergeTagsLink")), 1)
                  ])
                ]),
                _createVNode(_component_Editor, {
                  description: _ctx.editTemplateData.TemplateData.EmailBody,
                  "images-to-be-uploaded": _ctx.imagesToBeUploaded,
                  "module-type": _ctx.currentComponent.Invite,
                  onUpdatedDescription: _ctx.ChangeBodyDescription,
                  onImagesToBeUploaded: _ctx.SetImagesToBeUploadedData
                }, null, 8, ["description", "images-to-be-uploaded", "module-type", "onUpdatedDescription", "onImagesToBeUploaded"])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditEmail.RegistrationAction")), 1),
                _createElementVNode("div", _hoisted_35, [
                  _createElementVNode("div", _hoisted_36, [
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("label", _hoisted_38, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.editTemplateData.TemplateData.HasRegistrationLink) = $event)),
                          type: "radio",
                          value: false,
                          name: "registerButtonType",
                          onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.ChangeRadioType(false, _ctx.buttonType.Register)))
                        }, null, 512), [
                          [_vModelRadio, _ctx.editTemplateData.TemplateData.HasRegistrationLink]
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("Button")), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("label", _hoisted_40, [
                        _withDirectives(_createElementVNode("input", {
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.editTemplateData.TemplateData.HasRegistrationLink) = $event)),
                          type: "radio",
                          value: true,
                          name: "registerButtonType",
                          onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.ChangeRadioType(true, _ctx.buttonType.Register)))
                        }, null, 512), [
                          [_vModelRadio, _ctx.editTemplateData.TemplateData.HasRegistrationLink]
                        ]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t("Link")), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["display-flex", {'small-tab-display' : _ctx.isSmallTab}])
                  }, [
                    _createElementVNode("div", _hoisted_41, [
                      _createElementVNode("label", _hoisted_42, [
                        _createTextVNode(_toDisplayString(!_ctx.editTemplateData.TemplateData.HasRegistrationLink ? _ctx.$t("ButtonTitle") : _ctx.$t("Invite.ConfigureEmails.LinkTitle")) + " ", 1),
                        _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("Asteric")), 1)
                      ]),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.v$.editTemplateData.TemplateData.LabelText.$model) = $event)),
                        type: "text",
                        class: _normalizeClass(["form-control", _ctx.status(_ctx.v$.editTemplateData.TemplateData.LabelText)]),
                        maxlength: _ctx.maxButtonTextLength,
                        onInput: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.OnButtonTextChange && _ctx.OnButtonTextChange(...args)))
                      }, null, 42, _hoisted_44), [
                        [
                          _vModelText,
                          _ctx.v$.editTemplateData.TemplateData.LabelText.$model,
                          void 0,
                          { trim: true }
                        ]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_45, [
                      (!_ctx.editTemplateData.TemplateData.HasRegistrationLink)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                            _createElementVNode("label", _hoisted_47, _toDisplayString(_ctx.$t("Background")), 1),
                            _createElementVNode("div", {
                              class: "palette-container",
                              style: _normalizeStyle({'backgroundColor': _ctx.registerButtonBackgroundColor.hex})
                            }, [
                              (!_ctx.isPaletteSelected[3])
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "color-block",
                                    onClick: _cache[22] || (_cache[22] = _withModifiers(($event: any) => (_ctx.TogglePalette(3)), ["stop"]))
                                  }))
                                : _withDirectives((_openBlock(), _createBlock(_component_Twitter, {
                                    key: 1,
                                    modelValue: _ctx.registerButtonBackgroundColor,
                                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.registerButtonBackgroundColor) = $event)),
                                    class: "color-picker"
                                  }, null, 8, ["modelValue"])), [
                                    [_directive_click_outside, _ctx.HideAllPalattes]
                                  ])
                            ], 4)
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_48, [
                        _createElementVNode("label", _hoisted_49, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditEmail.TextColor")), 1),
                        _createElementVNode("div", {
                          class: "palette-container",
                          style: _normalizeStyle({'backgroundColor': _ctx.registerButtonFontColor.hex })
                        }, [
                          (!_ctx.isPaletteSelected[4])
                            ? (_openBlock(), _createElementBlock("span", {
                                key: 0,
                                class: "color-block",
                                onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.TogglePalette(4)), ["stop"]))
                              }))
                            : _withDirectives((_openBlock(), _createBlock(_component_Twitter, {
                                key: 1,
                                modelValue: _ctx.registerButtonFontColor,
                                "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.registerButtonFontColor) = $event)),
                                class: "color-picker"
                              }, null, 8, ["modelValue"])), [
                                [_directive_click_outside, _ctx.HideAllPalattes]
                              ])
                        ], 4)
                      ])
                    ])
                  ], 2)
                ]),
                (_ctx.HasEventWebPageAccessTemplate())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                      _createElementVNode("div", null, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EventPageAction")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createElementVNode("div", _hoisted_52, [
                          _createElementVNode("label", _hoisted_53, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.editTemplateData.TemplateData.HasEventWebPageAccessLink) = $event)),
                              type: "radio",
                              value: false,
                              name: "eventWebPageButtonType",
                              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.ChangeRadioType(false, _ctx.buttonType.EventWebPage)))
                            }, null, 512), [
                              [_vModelRadio, _ctx.editTemplateData.TemplateData.HasEventWebPageAccessLink]
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("Button")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_54, [
                          _createElementVNode("label", _hoisted_55, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.editTemplateData.TemplateData.HasEventWebPageAccessLink) = $event)),
                              type: "radio",
                              value: true,
                              name: "eventWebPageButtonType",
                              onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.ChangeRadioType(true, _ctx.buttonType.EventWebPage)))
                            }, null, 512), [
                              [_vModelRadio, _ctx.editTemplateData.TemplateData.HasEventWebPageAccessLink]
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("Link")), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["display-flex", {'small-tab-display' : _ctx.isSmallTab}])
                        }, [
                          _createElementVNode("div", _hoisted_57, [
                            _createElementVNode("label", _hoisted_58, [
                              _createTextVNode(_toDisplayString(!_ctx.editTemplateData.TemplateData.HasEventWebPageAccessLink ? _ctx.$t("ButtonTitle") : _ctx.$t("Invite.ConfigureEmails.LinkTitle")) + " ", 1),
                              _createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t("Asteric")), 1)
                            ]),
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.v$.editTemplateData.TemplateData.EventWebPageAccessLabelText.$model) = $event)),
                              type: "text",
                              class: _normalizeClass(["form-control", _ctx.status(_ctx.v$.editTemplateData.TemplateData.EventWebPageAccessLabelText)]),
                              maxlength: _ctx.maxButtonTextLength,
                              onInput: _cache[31] || (_cache[31] = 
//@ts-ignore
(...args) => (_ctx.OnButtonTextChange && _ctx.OnButtonTextChange(...args)))
                            }, null, 42, _hoisted_60), [
                              [
                                _vModelText,
                                _ctx.v$.editTemplateData.TemplateData.EventWebPageAccessLabelText.$model,
                                void 0,
                                { trim: true }
                              ]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_61, [
                            (!_ctx.editTemplateData.TemplateData.HasEventWebPageAccessLink)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                  _createElementVNode("label", _hoisted_63, _toDisplayString(_ctx.$t("Background")), 1),
                                  _createElementVNode("div", {
                                    class: "palette-container",
                                    style: _normalizeStyle({'backgroundColor': _ctx.eventWebPageButtonBackgroundColor.hex})
                                  }, [
                                    (!_ctx.isPaletteSelected[5])
                                      ? (_openBlock(), _createElementBlock("span", {
                                          key: 0,
                                          class: "color-block",
                                          onClick: _cache[32] || (_cache[32] = _withModifiers(($event: any) => (_ctx.TogglePalette(5)), ["stop"]))
                                        }))
                                      : _withDirectives((_openBlock(), _createBlock(_component_Twitter, {
                                          key: 1,
                                          modelValue: _ctx.eventWebPageButtonBackgroundColor,
                                          "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.eventWebPageButtonBackgroundColor) = $event)),
                                          class: "color-picker"
                                        }, null, 8, ["modelValue"])), [
                                          [_directive_click_outside, _ctx.HideAllPalattes]
                                        ])
                                  ], 4)
                                ]))
                              : _createCommentVNode("", true),
                            _createElementVNode("div", _hoisted_64, [
                              _createElementVNode("label", _hoisted_65, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditEmail.TextColor")), 1),
                              _createElementVNode("div", {
                                class: "palette-container",
                                style: _normalizeStyle({'backgroundColor': _ctx.eventWebPageButtonFontColor.hex })
                              }, [
                                (!_ctx.isPaletteSelected[6])
                                  ? (_openBlock(), _createElementBlock("span", {
                                      key: 0,
                                      class: "color-block",
                                      onClick: _cache[34] || (_cache[34] = _withModifiers(($event: any) => (_ctx.TogglePalette(6)), ["stop"]))
                                    }))
                                  : _withDirectives((_openBlock(), _createBlock(_component_Twitter, {
                                      key: 1,
                                      modelValue: _ctx.eventWebPageButtonFontColor,
                                      "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.eventWebPageButtonFontColor) = $event)),
                                      class: "color-picker"
                                    }, null, 8, ["modelValue"])), [
                                      [_directive_click_outside, _ctx.HideAllPalattes]
                                    ])
                              ], 4)
                            ])
                          ])
                        ], 2),
                        (_ctx.showEventPageNotPublishInformation)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_66, _toDisplayString(_ctx.$t('Invite.ConfigureEmails.EventPageNotPublishedText')), 1))
                          : _createCommentVNode("", true)
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.HasConfirmationTemplate())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                      _createElementVNode("div", _hoisted_68, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditButtonLabel")), 1)
                      ]),
                      _createElementVNode("div", _hoisted_69, [
                        _createElementVNode("div", _hoisted_70, [
                          _createElementVNode("label", _hoisted_71, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.editTemplateData.TemplateData.HasEditResponsesRegistrationLink) = $event)),
                              type: "radio",
                              value: false,
                              name: "editButtonType",
                              onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.ChangeRadioType(false , _ctx.buttonType.EditResponse)))
                            }, null, 512), [
                              [_vModelRadio, _ctx.editTemplateData.TemplateData.HasEditResponsesRegistrationLink]
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("Button")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("label", _hoisted_73, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.editTemplateData.TemplateData.HasEditResponsesRegistrationLink) = $event)),
                              type: "radio",
                              value: true,
                              name: "editButtonType",
                              onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.ChangeRadioType(true , _ctx.buttonType.EditResponse)))
                            }, null, 512), [
                              [_vModelRadio, _ctx.editTemplateData.TemplateData.HasEditResponsesRegistrationLink]
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("Link")), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["display-flex", {'small-tab-display' : _ctx.isSmallTab}])
                      }, [
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("label", _hoisted_75, [
                            _createTextVNode(_toDisplayString(!_ctx.editTemplateData.TemplateData.HasEditResponsesRegistrationLink ? _ctx.$t("ButtonTitle") : _ctx.$t("Invite.ConfigureEmails.LinkTitle")) + " ", 1),
                            _createElementVNode("span", _hoisted_76, _toDisplayString(_ctx.$t("Asteric")), 1)
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.v$.editTemplateData.TemplateData.EditResponsesLabelText.$model) = $event)),
                            type: "text",
                            class: _normalizeClass(["form-control", _ctx.status(_ctx.v$.editTemplateData.TemplateData.EditResponsesLabelText)]),
                            maxlength: _ctx.maxButtonTextLength,
                            onInput: _cache[41] || (_cache[41] = 
//@ts-ignore
(...args) => (_ctx.OnButtonTextChange && _ctx.OnButtonTextChange(...args)))
                          }, null, 42, _hoisted_77), [
                            [
                              _vModelText,
                              _ctx.v$.editTemplateData.TemplateData.EditResponsesLabelText.$model,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_78, [
                          (!_ctx.editTemplateData.TemplateData.HasEditResponsesRegistrationLink)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_79, [
                                _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t("Background")), 1),
                                _createElementVNode("div", {
                                  class: "palette-container",
                                  style: _normalizeStyle({'backgroundColor': _ctx.editButtonBackgroundColor.hex})
                                }, [
                                  (!_ctx.isPaletteSelected[7])
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "color-block",
                                        onClick: _cache[42] || (_cache[42] = _withModifiers(($event: any) => (_ctx.TogglePalette(7)), ["stop"]))
                                      }))
                                    : _withDirectives((_openBlock(), _createBlock(_component_Twitter, {
                                        key: 1,
                                        modelValue: _ctx.editButtonBackgroundColor,
                                        "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.editButtonBackgroundColor) = $event)),
                                        class: "color-picker"
                                      }, null, 8, ["modelValue"])), [
                                        [_directive_click_outside, _ctx.HideAllPalattes]
                                      ])
                                ], 4)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_81, [
                            _createElementVNode("label", _hoisted_82, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditEmail.TextColor")), 1),
                            _createElementVNode("div", {
                              class: "palette-container",
                              style: _normalizeStyle({'backgroundColor': _ctx.editButtonFontColor.hex })
                            }, [
                              (!_ctx.isPaletteSelected[8])
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "color-block",
                                    onClick: _cache[44] || (_cache[44] = _withModifiers(($event: any) => (_ctx.TogglePalette(8)), ["stop"]))
                                  }))
                                : _withDirectives((_openBlock(), _createBlock(_component_Twitter, {
                                    key: 1,
                                    modelValue: _ctx.editButtonFontColor,
                                    "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.editButtonFontColor) = $event)),
                                    class: "color-picker"
                                  }, null, 8, ["modelValue"])), [
                                    [_directive_click_outside, _ctx.HideAllPalattes]
                                  ])
                            ], 4)
                          ])
                        ])
                      ], 2)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.HasConfirmationTemplate())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                      _createElementVNode("div", _hoisted_84, [
                        _createElementVNode("label", null, _toDisplayString(_ctx.EventAccessLinkLabel()), 1)
                      ]),
                      _createElementVNode("div", _hoisted_85, [
                        _createElementVNode("div", _hoisted_86, [
                          _createElementVNode("label", _hoisted_87, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.editTemplateData.TemplateData.HasEventAccessLink) = $event)),
                              type: "radio",
                              value: false,
                              name: "eventAccessButtonType",
                              onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.ChangeRadioType(false , _ctx.buttonType.EventAccess)))
                            }, null, 512), [
                              [_vModelRadio, _ctx.editTemplateData.TemplateData.HasEventAccessLink]
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("Button")), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_88, [
                          _createElementVNode("label", _hoisted_89, [
                            _withDirectives(_createElementVNode("input", {
                              "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.editTemplateData.TemplateData.HasEventAccessLink) = $event)),
                              type: "radio",
                              value: true,
                              name: "eventAccessButtonType",
                              onClick: _cache[49] || (_cache[49] = ($event: any) => (_ctx.ChangeRadioType(true , _ctx.buttonType.EventAccess)))
                            }, null, 512), [
                              [_vModelRadio, _ctx.editTemplateData.TemplateData.HasEventAccessLink]
                            ]),
                            _createTextVNode(" " + _toDisplayString(_ctx.$t("Link")), 1)
                          ])
                        ])
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["display-flex", {'small-tab-display' : _ctx.isSmallTab}])
                      }, [
                        _createElementVNode("div", _hoisted_90, [
                          _createElementVNode("label", _hoisted_91, [
                            _createTextVNode(_toDisplayString(!_ctx.editTemplateData.TemplateData.HasEventAccessLink ? _ctx.$t("ButtonTitle") : _ctx.$t("Invite.ConfigureEmails.LinkTitle")) + " ", 1),
                            _createElementVNode("span", _hoisted_92, _toDisplayString(_ctx.$t("Asteric")), 1)
                          ]),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.v$.editTemplateData.TemplateData.EventAccessLabelText.$model) = $event)),
                            type: "text",
                            class: _normalizeClass(["form-control", _ctx.status(_ctx.v$.editTemplateData.TemplateData.EventAccessLabelText)]),
                            maxlength: _ctx.maxButtonTextLength,
                            onInput: _cache[51] || (_cache[51] = 
//@ts-ignore
(...args) => (_ctx.OnButtonTextChange && _ctx.OnButtonTextChange(...args)))
                          }, null, 42, _hoisted_93), [
                            [
                              _vModelText,
                              _ctx.v$.editTemplateData.TemplateData.EventAccessLabelText.$model,
                              void 0,
                              { trim: true }
                            ]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_94, [
                          (!_ctx.editTemplateData.TemplateData.HasEventAccessLink)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_95, [
                                _createElementVNode("label", _hoisted_96, _toDisplayString(_ctx.$t("Background")), 1),
                                _createElementVNode("div", {
                                  class: "palette-container",
                                  style: _normalizeStyle({'backgroundColor': _ctx.eventAccessButtonBackgroundColor.hex})
                                }, [
                                  (!_ctx.isPaletteSelected[9])
                                    ? (_openBlock(), _createElementBlock("span", {
                                        key: 0,
                                        class: "color-block",
                                        onClick: _cache[52] || (_cache[52] = _withModifiers(($event: any) => (_ctx.TogglePalette(9)), ["stop"]))
                                      }))
                                    : _withDirectives((_openBlock(), _createBlock(_component_Twitter, {
                                        key: 1,
                                        modelValue: _ctx.eventAccessButtonBackgroundColor,
                                        "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.eventAccessButtonBackgroundColor) = $event)),
                                        class: "color-picker"
                                      }, null, 8, ["modelValue"])), [
                                        [_directive_click_outside, _ctx.HideAllPalattes]
                                      ])
                                ], 4)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_97, [
                            _createElementVNode("label", _hoisted_98, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditEmail.TextColor")), 1),
                            _createElementVNode("div", {
                              class: "palette-container",
                              style: _normalizeStyle({'backgroundColor': _ctx.eventAccessButtonFontColor.hex })
                            }, [
                              (!_ctx.isPaletteSelected[10])
                                ? (_openBlock(), _createElementBlock("span", {
                                    key: 0,
                                    class: "color-block",
                                    onClick: _cache[54] || (_cache[54] = _withModifiers(($event: any) => (_ctx.TogglePalette(10)), ["stop"]))
                                  }))
                                : _withDirectives((_openBlock(), _createBlock(_component_Twitter, {
                                    key: 1,
                                    modelValue: _ctx.eventAccessButtonFontColor,
                                    "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.eventAccessButtonFontColor) = $event)),
                                    class: "color-picker"
                                  }, null, 8, ["modelValue"])), [
                                    [_directive_click_outside, _ctx.HideAllPalattes]
                                  ])
                            ], 4)
                          ])
                        ])
                      ], 2)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_99, [
              _createElementVNode("label", _hoisted_100, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditEmail.FooterSection")), 1),
              _createElementVNode("div", _hoisted_101, [
                _createElementVNode("div", _hoisted_102, [
                  _createElementVNode("label", _hoisted_103, _toDisplayString(_ctx.$t("Background")), 1),
                  _createElementVNode("div", {
                    class: "palette-container",
                    style: _normalizeStyle({'backgroundColor': _ctx.footerBackgroundColor.hex})
                  }, [
                    (!_ctx.isPaletteSelected[11])
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "color-block",
                          onClick: _cache[56] || (_cache[56] = _withModifiers(($event: any) => (_ctx.TogglePalette(11)), ["stop"]))
                        }))
                      : _withDirectives((_openBlock(), _createBlock(_component_Twitter, {
                          key: 1,
                          modelValue: _ctx.footerBackgroundColor,
                          "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.footerBackgroundColor) = $event)),
                          class: "color-picker"
                        }, null, 8, ["modelValue"])), [
                          [_directive_click_outside, _ctx.HideAllPalattes]
                        ])
                  ], 4)
                ]),
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("label", _hoisted_105, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditEmail.TextColor")), 1),
                  _createElementVNode("div", {
                    class: "palette-container",
                    style: _normalizeStyle({'backgroundColor': _ctx.footerFontColor.hex})
                  }, [
                    (!_ctx.isPaletteSelected[12])
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "color-block",
                          onClick: _cache[58] || (_cache[58] = _withModifiers(($event: any) => (_ctx.TogglePalette(12)), ["stop"]))
                        }))
                      : _withDirectives((_openBlock(), _createBlock(_component_Twitter, {
                          key: 1,
                          modelValue: _ctx.footerFontColor,
                          "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.footerFontColor) = $event)),
                          class: "color-picker"
                        }, null, 8, ["modelValue"])), [
                          [_directive_click_outside, _ctx.HideAllPalattes]
                        ])
                  ], 4)
                ])
              ]),
              _createElementVNode("div", _hoisted_106, [
                _createElementVNode("label", null, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditEmail.Content")), 1),
                _createVNode(_component_Editor, {
                  description: _ctx.editTemplateData.TemplateData.FooterContent,
                  "images-to-be-uploaded": _ctx.imagesToBeUploaded,
                  "module-type": _ctx.currentComponent.Invite,
                  onUpdatedDescription: _ctx.ChangeFooterDescription,
                  onImagesToBeUploaded: _ctx.SetImagesToBeUploadedData
                }, null, 8, ["description", "images-to-be-uploaded", "module-type", "onUpdatedDescription", "onImagesToBeUploaded"])
              ])
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["left-content-footer", {'small-tab-view' : _ctx.isSmallTab}])
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("button", {
                class: "outline-button",
                onClick: _cache[60] || (_cache[60] = ($event: any) => (_ctx.OpenSaveAsTemplatePopUp()))
              }, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EditEmail.SaveAsTemplate")), 1)
            ]),
            _createElementVNode("div", _hoisted_107, [
              _createElementVNode("button", {
                class: "btn btn-secondary btn-size-default btn-cancelevent",
                disabled: !_ctx.isPageDirty,
                onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.DiscardChanges()))
              }, _toDisplayString(_ctx.$t("Button.Discard")), 9, _hoisted_108),
              _createElementVNode("button", {
                class: "btn btn-primary btn-size-default btn-create-event margin-left-20",
                disabled: !_ctx.isPageDirty,
                onClick: _cache[62] || (_cache[62] = ($event: any) => (_ctx.SaveEmailConfigurations(_ctx.v$)))
              }, _toDisplayString(_ctx.$t("Button.Save")), 9, _hoisted_109)
            ])
          ], 2)
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["container-divider", {'small-tab-margin' : _ctx.isSmallTab}])
        }, null, 2),
        _createElementVNode("div", _hoisted_110, [
          _createElementVNode("div", _hoisted_111, [
            _createElementVNode("label", _hoisted_112, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.EmailPreview")), 1),
            _createElementVNode("a", {
              href: "javascript:void(0)",
              class: "change-template-link",
              onClick: _cache[63] || (_cache[63] = ($event: any) => (_ctx.EmitChangeTemplate()))
            }, _toDisplayString(_ctx.$t("Invite.ConfigureEmails.ChangeEmailTemplate")), 1)
          ]),
          _createElementVNode("div", _hoisted_113, [
            _createElementVNode("div", _hoisted_114, [
              _createVNode(_component_EmailTemplateRenderer, {
                "template-data": _ctx.editTemplateData,
                "bottom-margin": 30
              }, null, 8, ["template-data"])
            ])
          ]),
          _createElementVNode("div", _hoisted_115, [
            _createElementVNode("button", {
              class: "outline-button",
              onClick: _cache[64] || (_cache[64] = ($event: any) => (_ctx.OpenSendPreviewPopUp()))
            }, [
              _createElementVNode("img", {
                src: _ctx.emailIcon,
                class: "margin-right-5"
              }, null, 8, _hoisted_116),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("Invite.ConfigureEmails.SendPreviewMail")), 1)
            ])
          ])
        ])
      ], 32))
}